// extracted by mini-css-extract-plugin
export default {"icon":"_16yzL","reversedIcon":"_1hRt3","overflow":"t66yf","title":"_4oanz","mobile":"_1M3Ha","listContentTitleColor":"_37dj_"};